var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"digitizeBody"}},[_c('div',{staticClass:"centered white-text"},[_c('h3',{staticStyle:{"color":"#F0F0F0"}},[_vm._v(" "+_vm._s(_vm.$t('digitizeBody.digitizeBodyText'))+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }